<div class="kanban-acoes">
  <button class="btn btn-outline-primary" (click)="abrirConfiguracao()">
    <i class="fa fa-cog"></i> Configurar funil
  </button>
</div>

<div class="scrollbar-container">
  <div class="scrollbar-top" #scrollbarTop><div class="scrollbar-content"></div></div>
</div>

<div class="conteudo-kanbam" #conteudoKanbam>
  <div class="coluna-kanbam" *ngFor="let etapa of etapas; let indice = index">
    <div class="card card-titulo" [style.border-top-color]="etapa.cor">
      <div class="cabecalho-etapa">
        <div class="texto-status">
          {{ etapa.nome }}
          <p class="texto-valor">{{ etapa.total ? ('R$ ' + (etapa.total | number:'1.2-2')) : '-' }}</p>
        </div>
        <i class="fa fa-plus-circle icone-titulo" [style.color]="etapa.cor"
           (click)="abrirModalNovoAtendimento(etapa.codigo)"></i>
      </div>
    </div>

    <div class="card p-3 card-atendimento" *ngFor="let atendimento of etapa.atendimentos">
      <div class="linha" [style.background-color]="etapa.cor"></div>
      <div (click)="abrirDetalhes(atendimento.id)" class="row card-conteudo">
        <div class="fundo-iniciais" [style.background-color]="etapa.cor">{{ buscarIniciais(atendimento.solicitante) }}</div>
        <div class="texto-nome">{{ atendimento.solicitante }} <span class="atendimento-id">#{{ atendimento.id }}</span></div>
        <p class="texto-quebra"><i class="fa fa-money"></i> R$ {{ atendimento.valor }}</p>
        <p class="texto-quebra" *ngIf="atendimento.solicitanteEmail"><i class="fa fa-at"></i> {{ atendimento.solicitanteEmail }}</p>
        <p class="texto-quebra" *ngIf="atendimento.solicitanteTelefone"><i class="fa fa-mobile"></i> {{ atendimento.solicitanteTelefone }}</p>
        <p class="texto-quebra"><i class="fa fa-paperclip"></i> <span [innerHTML]="atendimento.descricaoResumida"></span></p>
      </div>
      <div class="rodape-atendimento">
        <p class="texto-data"><i class="fa fa-calendar"></i> {{ atendimento.dataModificacao | date:'dd MMM yyyy' }}</p>
        <div>
          <button class="btn btn-secondary botao-proximo" title="Anexar documento" (click)="abrirNovoDocumento(atendimento.id)">
            <i class="fa fa-paperclip"></i>
          </button>
          <button *ngIf="indice < etapas.length - 1" class="btn btn-primary botao-proximo"
                  [style.background-color]="etapa.cor" title="Avançar para {{ etapas[indice + 1].nome }}"
                  (click)="abrirModalAlterarStatus(atendimento.id, indice)">
            <i class="fa fa-forward"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="configuracao-overlay" *ngIf="showConfiguracao" (click)="showConfiguracao = false">
  <div class="configuracao-funil" (click)="$event.stopPropagation()">
    <div class="configuracao-titulo">
      <h4>Configurar funil do CRM</h4>
      <i class="fa fa-close" (click)="showConfiguracao = false"></i>
    </div>
    <p class="text-muted">As colunas aparecem no Kanban na ordem abaixo.</p>
    <div class="etapa-edicao" *ngFor="let etapa of etapasEdicao; let i = index">
      <input type="color" [(ngModel)]="etapa.cor" title="Cor da coluna">
      <input class="form-control" [(ngModel)]="etapa.nome" maxlength="100" placeholder="Nome da coluna">
      <button class="btn btn-light" (click)="moverEtapa(i, -1)" [disabled]="i === 0"><i class="fa fa-arrow-up"></i></button>
      <button class="btn btn-light" (click)="moverEtapa(i, 1)" [disabled]="i === etapasEdicao.length - 1"><i class="fa fa-arrow-down"></i></button>
      <button class="btn btn-outline-danger" (click)="removerEtapa(i)"><i class="fa fa-trash"></i></button>
    </div>
    <button class="btn btn-outline-primary" (click)="adicionarEtapa()"><i class="fa fa-plus"></i> Nova coluna</button>
    <div class="configuracao-rodape">
      <button class="btn btn-light" (click)="showConfiguracao = false">Cancelar</button>
      <button class="btn btn-primary" (click)="salvarConfiguracao()">Salvar funil</button>
    </div>
  </div>
</div>

<app-cadastro-novo-atendimento [showModal]="showModalAtendimento" [statusInicial]="statusSelecionado"
  (fecharModalPai)="fecharModal()"></app-cadastro-novo-atendimento>

<app-alterar-status-agendamento [showModal]="showModalAlterarStatus" [atendimentoId]="atendimentoSelecionadoId"
  [statusDestino]="statusDestino" [nomeStatusDestino]="nomeStatusDestino"
  (fecharModalPai)="fecharModalAlterarStatus()"></app-alterar-status-agendamento>

<app-lead-novo-documento [showModal]="showModalNovoDocumento" [atendimentoId]="atendimentoSelecionadoId"
  (fecharModalPai)="showModalNovoDocumento = false"></app-lead-novo-documento>
